export default "__VITE_ASSET__BVmzuwhu__"